import React, { createContext, useContext } from "react";

/**
 * The two slots History keeps on its tab strip line.
 *
 * Tabs render their controls into these instead of above the table: a "Clear
 * Filters" pill or a Regenerate button appearing in its own row pushed every
 * table row down the moment a filter was applied. The tab line already exists,
 * so nothing moves.
 *
 * DOM nodes handed through context and written with `createPortal`, rather than
 * a `setState(node)` registration: a portal re-renders with the owning
 * component's state, so a filter count updates without an effect that has to
 * re-register on every change (and can loop when the node is rebuilt each
 * render).
 *
 * Two slots rather than one because order matters and portal insertion order
 * doesn't: `filters` sits to the left of `actions`, per the design.
 */
export interface HistoryToolbarSlots {
  /** For the "Clear Filters" pill. Left of `actions`. */
  filters: HTMLElement | null;
  /** For per-tab buttons — Prescription's Regenerate / New Prescription. */
  actions: HTMLElement | null;
}

const HistoryToolbarContext = createContext<HistoryToolbarSlots>({
  filters: null,
  actions: null,
});

export const HistoryToolbarProvider = HistoryToolbarContext.Provider;

export const useHistoryToolbarSlots = (): HistoryToolbarSlots =>
  useContext(HistoryToolbarContext);
